export default __webpack_public_path__ + "static/media/jslogo.1fbd7aa5.png";